import { FC, PropsWithChildren, useCallback, useState } from "react";
import { Locale } from "../../api/dtos";
import LocaleActionContext from "../../contexts/LocaleActionContext";
import LocaleContext from "../../contexts/LocaleContext";
import i18n from "../../i18n";

interface ILocaleProviderProps extends PropsWithChildren {
    
}

const LocaleProvider: FC<ILocaleProviderProps> = ({
    children
}) => {
    const [ locale, setLocale ] = useState<Locale | undefined>(undefined);

    const handleChange = useCallback(async (l?: Locale) => {
        setLocale(l);
        i18n.changeLanguage(l?.code ?? "en");
    }, [])
    
    return (
        <LocaleContext.Provider 
            value={{
                data: locale
            }}
        >
            <LocaleActionContext.Provider 
                value={{
                    setLocale: handleChange
                }}
            >
                {children}
            </LocaleActionContext.Provider>
        </LocaleContext.Provider>
    )
}

export default LocaleProvider;